import * as React from 'react';
import S from './SectionWrapper.styles';
const SectionWrapper = React.forwardRef(({ children, className, flush, fullWidth = false, innerWidth = 'default', spacing: spacingOverride, themeOption = 'light', ...otherProps }, ref) => {
    const spacing = spacingOverride ?? (themeOption === 'light' ? 'margin' : 'padding');
    return (React.createElement(S.Container, { ref: ref, className: className, flush: flush, spacing: spacing, themeOption: themeOption, ...otherProps }, fullWidth ? children : React.createElement(S.SiteWide, { width: innerWidth }, children)));
});
SectionWrapper.displayName = 'SectionWrapper';
export default SectionWrapper;
